<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" id="ch6" title="How Do People Hot-Wire Cars?">
<p class="h2a"><a href="#/text/Contents#rch6">How Do People Hot-Wire Cars?</a></p>
<p class="noindent1">Hot-wiring a car involves bypassing the ignition interlock and starting the car without a key. In many films, this process is done very quickly by a car thief who fiddles with a few wires under the steering wheel. Some sparks appear, the car starts, and he speeds away. But is it really that easy?</p>
<p class="indent">With cars made after about the year 2000, it’s not. Starting them requires digital verification from a chip in the car key. These cars also include a steering column lock and other safety mechanisms, so crossing wires together won’t work. Perhaps surprisingly, however, hot-wiring will work for most cars made before that time. Here’s how it’s done.</p>
<p class="indent">After the plastic covering around the steering wheel column is removed, various wires will be exposed. There are usually three sets of wires. Typically, the bundles to the left and right operate things such as lights and windshield wipers, so the wires you’re after will run straight up the center of the column. These are the ignition wires (usually brown), the starter wires (usually yellow), and the battery wires (almost always red).</p>
<p class="indent">Once the wires are located, strip an inch of insulation from the two battery wires and twist them together to provide power for the ignition components. Then connect the ignition wire to the battery wire. This will cause the dash lights and other electrical components to start. Now, here comes the dangerous part. Strip half an inch of insulation from the starter wire, which will be live, and touch it to the end of the connected battery wires. The car will start and you can drive away. The starter wire can be detached at this point. When you want to stop the engine, simply unfasten the ignition wire from the battery wires.</p>
<p class="indent">A more permanent method of starting a car is to drill into the ignition key hole. The idea is to destroy the various lock pins. Once this is done, you can insert a screwdriver and turn it like a key, and the car should start.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter006.vue?1cc6de3e